<template>
    <div class="type1">
      <a-row :gutter="20">
        <a-col :span="18" class="left-panel">
          <div class="title info-row">
            数据范围选择
          </div>
          <div>
            <div class="group-title info-row">
              选择患者
            </div>
            <a-radio-group v-model="patientType" style="width: 100%" class="info-row">
              <a-row >
                <a-col :span="6">
                  <a-radio value="1">
                    条件筛选患者
                  </a-radio>
                </a-col>
                <a-col :span="6">
                  <a-radio value="2">
                    选择指定患者
                  </a-radio>
                </a-col>
              </a-row>
            </a-radio-group>
          </div>
          <div v-if="patientType=='2'">
            <div style="margin-top: 10px" >
              <div style="padding: 10px">
                <template v-for="(item,index) in patientNameList">
                  <a-tag  :key="patientIdList[index]" closable color="blue" @close="patientNameClose(index)" style="margin-right: 10px;margin-bottom: 2px">
                    <!--<label @click="patientNameClose(index)">-->
                    {{item}}
                    <!--</label>-->
                  </a-tag>
                </template>
              </div>
              <patient-list list-url="/patient/patient/list2" :mini="true"  @onselect="handleSelect" @onmove="moveSelect">
                <template v-slot:btnSelectAll="slotProps">
                  <a-button type="primary" @click="handleSelectAll(slotProps.data)" style="margin-left: 5px"> 选择当前页</a-button>
                </template>
              </patient-list>
            </div>
          </div>
          <template v-else>
            <div>
              <div class="group-title info-row">
                选择分中心
              </div>
              <div class="group-title info-row">
                <a-checkbox v-if="!data.id" :indeterminate="center.indeterminate" :checked="center.checkAll" @change="centerCheckChange($event,center)">
                  全选
                </a-checkbox>
              </div>
              <a-checkbox-group v-model="center.checkedList" @change="onCenterCheckGroupChange($event,center)" style="width: 100%" class="info-row">
                <a-row >
                  <a-col :span="6" v-for="(item,index) in center.dataList" :key="index">
                    <a-checkbox :value="item.value">
                      {{item.text}}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </div>
            <div>
              <div class="group-title info-row">
                选择组别
              </div>
              <div class="group-title info-row">
                <a-checkbox v-if="!data.id" :indeterminate="group.indeterminate" :checked="group.checkAll" @change="centerCheckChange($event,group)">
                  全选
                </a-checkbox>
              </div>
              <a-checkbox-group v-model="group.checkedList" @change="onCenterCheckGroupChange($event,group)" style="width: 100%" class="info-row">
                <a-row >
                  <a-col :span="6" v-for="(item,index) in group.dataList" :key="index">
                    <a-checkbox :value="item.value">
                      {{item.text}}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </div>
            <div>
              <div class="group-title info-row">
                日期筛选
              </div>
              <div class="group-title info-row">
                注册日期：
                <a-date-picker value-format='YYYY-MM-DD' v-model="startCreateTime" />
                ~
                <a-date-picker value-format='YYYY-MM-DD' v-model="endCreateTime" />
              </div>
              <div class="group-title info-row">
                通过筛选日期：
                <a-date-picker value-format='YYYY-MM-DD' v-model="startPassDate" />
                ~
                <a-date-picker value-format='YYYY-MM-DD' v-model="endPassDate" />
              </div>
              <div class="group-title info-row">
                受试者编号：
                <a-input-number v-model="startPatientNum" placeholder="请输入"  :precision="0" style="width: 200px"/>
                ~
                <a-input-number v-model="endPatientNum" placeholder="请输入"  :precision="0" style="width: 200px"/>
              </div>
            </div>
          </template>

          <div>
            <div class="group-title info-row">选择周期及对应CRF</div>
            <div class="info-row ">
              <a-checkbox-group v-model="periodSelectInfo.checkedList" style="width: 100%"  @change="onCenterCheckGroupChange($event,periodSelectInfo)">
                <a-table
                  rowKey="value"
                  :columns="periodColumns"
                  :pagination="false"
                  :data-source="periodSelectInfo.dataList">
                  <div slot="checkboxTitle" >
                    <a-checkbox-group v-if="!data.id" v-model="periodSelectInfo.checkedAllValueList">
                      <a-checkbox :indeterminate="periodSelectInfo.indeterminate" value="1"  @change="centerCheckChange($event,periodSelectInfo)">
                      </a-checkbox>
                    </a-checkbox-group>
                  </div>
                  <div slot="checkbox" slot-scope="text, record"  >
                    <a-checkbox :value="record.value+''" :indeterminate="record.indeterminate"  @change="centerCheckChange($event,record)">
                    </a-checkbox>
                  </div>
                  <div  slot="dataList" slot-scope="text, record" style="text-align: left">
                    <a-checkbox-group v-model="record.checkedList"  style="width: 100%"  @change="onCenterCheckGroupChange($event,record,periodSelectInfo)">
                      <a-row :gutter="20">
                        <a-col :span="8" v-for="(item,index) in record.dataList" :key="index">
                          <a-checkbox :value="item.value+''" class="one-row">
                            <a-tooltip>
                              <template slot="title">
                                {{item.name}}
                              </template>
                              {{item.name}}
                            </a-tooltip>
                          </a-checkbox>
                        </a-col>
                      </a-row>
                    </a-checkbox-group>
                  </div>
                </a-table>
              </a-checkbox-group>
            </div>

          </div>
        </a-col>
        <a-col :span="6" class="right-panel">
          <div class="title info-row"> 导出结构配置</div>
          <div>
            <div class="group-title info-row">表头配置</div>
            <div>
              <a-radio-group v-model="titleConfig" class="info-row">
                <a-radio value="CN">
                  中文名称
                </a-radio>
                <!--<a-radio value="EN">-->
                  <!--英文代码-->
                <!--</a-radio>-->
              </a-radio-group>
            </div>
          </div>
          <div>
            <div class="group-title info-row">特殊题型</div>
            <a-table
              class="info-row"

              rowKey="questionType"
              :columns="questionColumns"
              :pagination="false"
              :data-source="questionData">
              <div  slot="requireList" slot-scope="text, record" style="text-align: left">
                <a-checkbox-group v-model="record.checkedList"  v-if="record.questionType==='checkbox'" style="width: 100%" >
                    <span v-for="(item,index) in record.requireList" :key="index">
                      <a-checkbox :value="item.value" >
                        {{item.name}}
                      </a-checkbox>
                      <a-tooltip>
                        <template slot="title">
                          {{item.description}}
                        </template>
                        <a-icon type="question-circle" />
                      </a-tooltip>
                    </span>
                </a-checkbox-group>
                <a-radio-group v-model="record.checkedList" v-if="record.questionType==='radio'" >
                  <a-radio :value="item.value" v-for="(item,index) in record.requireList" :key="index">
                    {{item.name}}
                    <a-tooltip>
                      <template slot="title">
                        {{item.description}}
                      </template>
                      <a-icon type="question-circle" />
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
              </div>
            </a-table>
          </div>
          <div>
            <div class="group-title info-row">特殊配置</div>
            <div>
              <a-checkbox-group v-model="specialChecked" class="info-row" >
                <a-checkbox value="1" style="margin-left: 7px">
                  导出元素说明
                  <a-tooltip>
                    <template slot="title">
                      变量名下展示变量类型及其值域，用于直观参考
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </a-checkbox>
                <a-checkbox value="2">
                  导出隐藏元素
                  <a-tooltip>
                    <template slot="title">
                      导出表单中配置为隐藏状态的元素
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </a-checkbox>
                <a-checkbox value="3">
                  导出录音文件
                  <a-tooltip>
                    <template slot="title">
                      导出采集数据对应的录音文件
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </a-checkbox>
                <a-checkbox value="4">
                  导出自定义表单
                  <a-tooltip>
                    <template slot="title">
                      导出受试者的自定义表单，非项目统一填写的访视表单
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </a-checkbox>
              </a-checkbox-group>
            </div>
          </div>
            <div>
              <div class="group-title info-row">
                导出格式
              </div>
              <div>
                <a-radio-group v-model="formatChecked" class="info-row" >
                  <a-radio value="1">
                    excel
                  </a-radio>
                  <!-- <a-radio value="2">
                    csv
                  </a-radio> -->
                </a-radio-group>
              </div>
              <div v-show="formatChecked==='1'" class="info-row">
                <a-select
                  placeholder="请选择"
                  style="width: 100%"
                  v-model="formatCheckedExcel.selected"
                >
                  <a-select-option :value="item.value" v-for="(item,index) in formatCheckedExcel.dataList" :key="index">{{item.text}}</a-select-option>
                </a-select>
              </div>
              <div v-show="formatChecked==='2'" class="info-row">
                <a-select
                  placeholder="请选择"
                  style="width: 100%"
                  v-model="formatCheckedCsv.selected"
                >
                  <a-select-option :value="item.value" v-for="(item,index) in formatCheckedCsv.dataList" :key="index">{{item.text}}</a-select-option>
                </a-select>
                <div class="group-title info-row">
                  文件编码
                  <a-radio-group v-model="formatCheckedCsv.encodeSelected" >
                    <a-radio value="UTF-8">
                      UTF-8
                    </a-radio>
                    <a-radio value="GBK">
                      GBK
                    </a-radio>
                  </a-radio-group>
                </div>
              </div>
          </div>
          <div class="export-btn" >
            <a-button type="primary" @click="createExportHandle" :loading="loading" v-if="!data.id">导出</a-button>
          </div>
        </a-col>
      </a-row>
    </div>
</template>

<script>
  import manyCheck from '@/utils/components/manyCheck'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  import PatientList from '@/views/project/patient/components/register/PatientList'
  export default {
    name: 'Type1',
    components: { PatientList },
    props:{
      data:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    data(){
      return{
        loading:false,
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        titleConfig:'CN',
        questionType:'1',
        questionFileType:'1',
        questionColumns:[
          {
            title: '特殊元素类型',
            align: "center",
            dataIndex: 'questionTypeName',
            key: 'questionType',
            width:150
          },
          {
            title: '导出要求',
            align: "center",
            dataIndex: 'requireList',
            key: 'requireList',
            scopedSlots: { customRender: 'requireList' },
          },
        ],
        questionData:[
          {
            questionTypeName:'单选、多选型',
            requireList:[
              {
                value:'1',
                name:'导出码值',
                description:'导出对应码值，可导出CRF注释表。了解带代码与描述的对应关系。',
              },
              {
                value:'2',
                name:'导出描述',
                description:'导出文本类型描述',
              },
              // {
              //   value:'3',
              //   name:'导出分数+描述',
              //   description:'导出分数+描述',
              // },
              // {
              //   value:'4',
              //   name:'导出分数+码值',
              //   description:'导出分数+码值',
              // }
            ],
            questionType:'radio',
            checkedList:'1',
          },
          {
            questionTypeName:'文件型',
            requireList:[
              {
                value:'1',
                name:'导出文件附件',
                description:'伴随采集数据一起导出',
              }
            ],
            questionType:'checkbox',
            checkedList:[],
          }
        ],
        specialChecked:[],
        formatChecked:'1',
        formatCheckedExcel:{
          selected:'1',
          dataList:[
            {text:'每个周期每个表单单独一个excel',value:'1'},
            {text:'一个周期一个excel，周期的每张表单单独一个sheet',value:'2'},
            {text:'一个周期一个excel，周期的所有表单合并一个sheet',value:'3'},
          ]
        },
        formatCheckedCsv:{
          selected:'1',
          encodeSelected:'GBK',
          dataList:[
            {text:'每个周期每个表单单独一个csv',value:'1'},
            {text:'一个周期所有表单合并为一个csv',value:'3'},
          ]
        },
        periodColumns:[
          {
            align: "center",
            dataIndex: '#',
            key: '#',
            slots: { title: 'checkboxTitle' },
            scopedSlots: { customRender: 'checkbox' },
            width:40,
          },
          {
            title: '周期',
            align: "center",
            dataIndex: 'name',
            key: 'name',
            width:120
          },
          {
            title: '表单',
            align: "center",
            dataIndex: 'dataList',
            key: 'dataList',
            scopedSlots: { customRender: 'dataList' },
          },
        ],
        periodSelectInfo:{
          checkedAllValue:'1',
          checkedAllValueList:['1'],
          indeterminate:false,
          checkedList:[],
          dataList:[
          ],
        },

        center:{
          indeterminate:false,
          checkedList:[],
          checkAll:true,
          dataList:[
            // {text:'四川大学华西医院',value:'HX'},
          ]
        },
        group:{
          indeterminate:false,
          checkedList:[
            // '1'
          ],
          checkAll:true,
          dataList:[
            // {text:'运动损伤队列',value:'1'},
          ]
        },
        /////
        patientIdList:[],
        patientNameList:[],
        patientType:'1',
        startPassDate:'',
        endPassDate:'',
        startCreateTime:'',
        endCreateTime:'',
        startPatientNum:'',
        endPatientNum:'',
      }
    },
    mounted(){
    },
    methods:{
      loadDataViewForm(){
        if(!this.data.id){
          return
        }
        // periodSelectInfo
        const formConfig = JSON.parse(this.data.formConfig)
        const checkedList = []
        for (let periodId in formConfig){
          checkedList.push(periodId)
          const formIdList = formConfig[periodId].split(',')
          this.periodSelectInfo.dataList.forEach(item=>{
            if(item.value===periodId){
              item.checkedList =  formIdList
            }
          })
        }
        this.periodSelectInfo.checkedList = checkedList
      },
      loadDataView(){
        //回显
        if(this.data.id){
          {
            // centerIds
            if(this.data.centerIds){
              this.center.checkedList =this.data.centerIds.split(',')
            }
          }
          {
            // groupIds
            if(this.data.groupIds){
              this.group.checkedList =this.data.groupIds.split(',')
            }
          }
          {
            if(this.data.patientType){
              this.patientType = this.data.patientType
            }
          }
          {
            if(this.data.patientIds){
              this.patientIdList = this.data.patientIds.split(',')
            }
            if(this.data.patientNames){
              this.patientNameList = this.data.patientNames.split(',')
            }
          }
          {
            this.startCreateTime = this.data.startCreateTime || ''
            this.endCreateTime = this.data.endCreateTime || ''
            this.startPassDate = this.data.startPassDate || ''
            this.endPassDate = this.data.endPassDate || ''
            this.startPatientNum = this.data.startPatientNum || null
            this.endPatientNum = this.data.endPatientNum || null
          }
          //   titleConfig:titleConfig,
          {
            this.titleConfig = this.data.titleConfig
          }
          //   radioConfig:radioConfig,
          {
            this.questionData[0].checkedList = this.data.radioConfig
          }
          //   fileConfig:fileConfig,
          {
            this.questionData[1].checkedList = this.data.fileConfig ?this.data.fileConfig.split(","):[]
          }
          //   specialConfig:specialConfig,
          {
            this.specialChecked = this.data.specialConfig?this.data.specialConfig.split(','):[]
          }
          //   format:format,
          {
            this.formatChecked = this.data.formatType
          }
          {
            //   formatConfig:formatConfig,
            if(this.data.format==='1'){
              this.formatCheckedExcel.selected = this.data.formatConfig
            }else{
              this.formatCheckedCsv.selected = this.data.formatConfig
              //   csvCode:csvCode,
              this.formatCheckedCsv.encodeSelected = this.data.csvCode
            }
          }
        }
      },
      loadData(){
        this.loadDataView()
        // 中心
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            const checkedList = []
            const dataList = []
            res.result.forEach(center=>{
              checkedList.push(center.centerId);
              const centerInfo = {
                text:center.center.name,
                value:center.centerId,
              }
              dataList.push(centerInfo)
            })
            this.$set(this.center,'dataList',dataList)
            if(!this.data.id){
              this.$set(this.center,'checkedList',checkedList)
            }
          }
        })
        // 组别
        getAction('/project/projectGroup/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            const checkedList = []
            const dataList = []
            res.result.forEach(data=>{
              checkedList.push(data.id);
              const dataInfo = {
                text:data.name,
                value:data.id
              }
              dataList.push(dataInfo)
            })
            this.$set(this.group,'dataList',dataList)
            if(!this.data.id){
              this.$set(this.group,'checkedList',checkedList)
            }
          }
        })
        // 周期表单
        getAction('/project/projectPeriodItem/listAndItem',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            const checkedList = []
            const dataList = []
            res.result.forEach(data=>{
              checkedList.push(data.id);
              const dataInfo = {
                name:data.name,
                value:data.id,
                indeterminate:false,
                checkAll:true,
              }
              // 处理表单
              const formCheckedList = []
              const formDataList = []
              data.formList.forEach(form=>{
                if(!this.data.id){
                  formCheckedList.push(form.formId);
                }
                const formDataInfo = {
                  name:form.formName,
                  value:form.formId,
                }
                formDataList.push(formDataInfo)
              })
              dataInfo.checkedList = formCheckedList
              dataInfo.dataList = formDataList
              dataList.push(dataInfo)
            })
            this.$set(this.periodSelectInfo,'dataList',dataList)
            if(!this.data.id){
              this.$set(this.periodSelectInfo,'checkedList',checkedList)
            }
            this.loadDataViewForm()
          }
        })
      },
      centerCheckChange(e,groupInfo){
        manyCheck.centerCheckChange(e,groupInfo)
      },
      onCenterCheckGroupChange(e,groupInfo,parent){
        manyCheck.onCenterCheckGroupChange(e,groupInfo,parent)
      },
      createExportHandle(){
        if(this.patientType==='2' && this.patientIdList.length==0){
          return this.$message.warning('请选择患者');
        }
        const centerIds = this.center.checkedList.join(',')
        if(!centerIds){
          return this.$message.warning('请选择中心');
        }
        const groupIds = this.group.checkedList.join(',')
        if(!groupIds){
          return this.$message.warning('请选择组别');
        }
        const periodFormJson = {}
        this.periodSelectInfo.dataList.forEach(period=>{
          if(period.checkedList&&period.checkedList.length>0){
            periodFormJson[period.value] = period.checkedList.join(',')
          }
        })
        const formConfig = JSON.stringify(periodFormJson);
        if(formConfig === '{}'){
          return this.$message.warning('请选择周期及对应CRF');
        }
        const titleConfig = this.titleConfig
        const radioConfig = this.questionData[0].checkedList
        const fileConfig = this.questionData[1].checkedList.join(',')
        const specialConfig = this.specialChecked.join(',')
        const format = this.formatChecked
        let formatConfig;
        let csvCode = ''
        if(format==='1'){
          formatConfig = this.formatCheckedExcel.selected
        }else{
          formatConfig = this.formatCheckedCsv.selected
          csvCode = this.formatCheckedCsv.encodeSelected
        }
        const params = {
          startCreateTime:this.startCreateTime,
          endCreateTime:this.endCreateTime,
          startPassDate:this.startPassDate,
          endPassDate:this.endPassDate,
          startPatientNum:this.startPatientNum,
          endPatientNum:this.endPatientNum,
          patientType:this.patientType,
          patientIds:this.patientIdList.join(','),
          patientNames:this.patientNameList.join(','),
          centerIds:centerIds,
          groupIds:groupIds,
          formConfig:formConfig,
          titleConfig:titleConfig,
          radioConfig:radioConfig,
          fileConfig:fileConfig,
          specialConfig:specialConfig,
          formatType:format,
          formatConfig:formatConfig,
          csvCode:csvCode,
          projectId:this.projectId,
          type:'1'
        }
        this.loading = true
        postAction('/export/projectExport/create',params).then(res=>{
          if(res.success){
            this.$emit("back")
            this.$message.success(res.message)
          }else{
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleSelect(record){
        if(this.patientIdList.indexOf(record.id)>=0){
          return
        }
        this.patientIdList.push(record.id)
        this.patientNameList.push(record.name || record.patientNum)
      },
      moveSelect(record){
        let index = this.patientIdList.indexOf(record.id);        
        if(index < 0){
          return
        }
        this.patientIdList.splice(index, 1)
        this.patientNameList.splice(index, 1)
      },
      handleSelectAll(data){
        data.forEach(item=>{
          this.handleSelect(item)
        })
      },
      patientNameClose(i){
        this.patientIdList.splice(i,1);
        this.patientNameList.splice(i,1);
      },
    }
  }
</script>

<style scoped lang="less">


</style>